import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    paymentOverview: 'Naar je facturen',
    secureConnection: 'Veilige verbinding',
  },
  en: {},
};
